<script setup lang="ts">
  import { computed, PropType } from 'vue'
  import { CommonErrorI } from '@/typescript/types/abstracts/errors/ErrorHandlerTypes'

  const props = defineProps({
    error: {
      type: [Object, String] as PropType<CommonErrorI | string | null | undefined>,
      default: () => ({}),
    },
    fieldId: {
      type: String,
      default: '',
    },
  })

  const errorId = computed(() => (props.fieldId ? `${props.fieldId}-error` : undefined))
  const displayErrorMessage = computed(() =>
    typeof props.error === 'string' ? props.error : (props.error?.message ?? ''),
  )
</script>
<template>
  <div v-if="error" :id="errorId" role="alert" class="main-red-text size12-weight400" data-test-id="field-error">
    {{ displayErrorMessage }}
  </div>
</template>
